"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { GlobalPageHeader } from "@/components";

function LegalPageHeader(): ReactElement {
  const t = useTranslations("legal.LegalPageHeader");
  return <GlobalPageHeader title={t("title")} />;
}

export { LegalPageHeader };
